import React from 'react';
import { IGaugePanel } from '../../../../../../../../theme/ui/Dashboard/Dashboard.model';
import { StorePanelProps } from './StorePanel';
import GaugePanel from '../../../../../../../../theme/ui/Dashboard/GaugePanel/GaugePanel';
import { MultiStoreIcon } from '../../../../../../../../assets/dashboard';
import { useTranslation } from 'react-i18next';
import { CommanderAPI } from '../../../../../../../../service/device/CommanderAPI/CommanderAPI';
import { Alert } from '@mui/material';
import { patchLoadingState } from '../../../../../../../../service/device/CommanderAPI/hooks/useAirConnectStatusCount';
import { M_SECONDS_POOLING_INTERVAL_DATA } from '../../../../../../../../service/store/Store.constants';

function StoreUserPanel(props: StorePanelProps) {
  const { panel, layout } = props;
  const response = CommanderAPI.useGetDevicesConnectionStatusCountByUserQuery(
    undefined,
    {
      pollingInterval: M_SECONDS_POOLING_INTERVAL_DATA,
    }
  );
  const {
    isLoading,
    currentData,
    error: errorDevicesConnectionStatus,
  } = patchLoadingState(response);

  const [t] = useTranslation();

  const gaugePanel: IGaugePanel = {
    ...panel,
    type: 'GAUGE',
    gaugeProps: {
      value: currentData?.mqttConnected ?? 0,
      valueMax: currentData ? currentData.count : 0,
    },
    loading: isLoading,
    icon: <MultiStoreIcon height={'100%'} />,
    labelValueActive: t('dashboard.stores.online'),
    labelValueInactive: t('dashboard.stores.offline'),
  };
  if (errorDevicesConnectionStatus)
    return <Alert severity="error">{t('dashboard.error.fetching')}</Alert>;
  return <GaugePanel panel={gaugePanel} layout={layout} />;
}

export default StoreUserPanel;
